import React from 'react';
import { ConfigurableLink } from 'swag-client-common/components/utils/configurable-link';
import { USER_ROLES } from 'swag-common/constants/user-roles';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes.sendoso';
import classes from './account-dropdown.scss';
export const OtherLinks = ({
  userRole
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, userRole === USER_ROLES.SENDOSO_SUPERVISOR && /*#__PURE__*/React.createElement(ConfigurableLink, {
    dataLink: "SupervisorDashboard",
    className: classes.dropdownItem,
    link: APP_ROUTES.SUPERVISOR_DASHBOARD_ORDER_APPROVAL
  }, "Supervisor Dashboard"));
};